import Socials from "./Socials";
import "../../css/Header.css";
import "../../css/Dropdown.css";

import { useContext, useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import LanguageContext from "../../context/language-context";
import LanguageMenu from "./LanguageMenu";

export default function Header(props) {
  const languageCtx = useContext(LanguageContext);
  const [activeMenu, setActiveMenu] = useState("");
  const location = useLocation();
  const headerRef = useRef(null);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isScrolling, setIsScrolling] = useState(false);
  const [isNotHome, setIsNotHome] = useState(location.pathname !== "/");
  const [isNotGroup, setIsNotGroup] = useState(location.pathname !== "/group");

  useEffect(() => {
    // Check if the route is not home
    setIsNotHome(location.pathname !== "/" || location.pathname == "/group");
    if (location.pathname !== "/") {
      const activeMenuFromStorage = localStorage.getItem("activeMenu");
      if (activeMenuFromStorage) {
        setActiveMenu(activeMenuFromStorage);
      }
    }
  }, [location]);

  const handleScroll = () => {
    const scrollY = window.scrollY;

    if (headerRef.current) {
      if (scrollY < lastScrollY) {
        // Scrolling up
        headerRef.current.style.top = "0px";
      }

      // Set isScrolling to true when scrolling
      setIsScrolling(scrollY !== 0);
    }

    setLastScrollY(scrollY);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  const handleMenuClick = (menu) => {
    setActiveMenu(menu);
    localStorage.setItem("activeMenu", menu);
  };

  const { loading, error, data } = useFetch(
    `https://spagnoladmin.spagnolcompany.it/api/headers?locale=${languageCtx.languageData}&populate[0]=Logo&populate[1]=White_Logo`
  );
  if (loading) return <p>Loading...</p>;
  const black = data.data[0].attributes.Logo.data.attributes.url;
  const white = data.data[0].attributes.White_Logo.data.attributes.url;

  return (
    <>
      <header>
        <div
          className={`Desktopview ${
            isScrolling || (isNotHome && isNotGroup) ? "has-bg" : ""
          }`}
          ref={headerRef}
        >
          <div className="container-fluid">
            <div className="navbar-brand">
              <a href="/" onClick={() => handleMenuClick("home")}>
                <img
                  loading="lazy"
                  src={
                    props.showdropdown ||
                    isScrolling ||
                    (isNotHome && isNotGroup)
                      ? `https://spagnoladmin.spagnolcompany.it${black}`
                      : `https://spagnoladmin.spagnolcompany.it${white}`
                  }
                  className="isBlack1"
                />
              </a>
            </div>
            <div className="left-most">
              <div className="navbar-brand">
                <LanguageMenu />
              </div>
              <Socials
                area={data.data[0].attributes.Area_Riservata}
                facebook={data.data[0].attributes.Facebook}
                instagram={data.data[0].attributes.Instagram}
                x={data.data[0].attributes.X}
                pinterest={data.data[0].attributes.Pinterest}
                youtube={data.data[0].attributes.Youtube}
              />
            </div>

            <div className="right-most">
              <ul className="menulist">
                <li>
                  <a
                    href="/group"
                    onClick={() => handleMenuClick("group")}
                    className={`menuitem cataloghi ${
                      activeMenu === "group" ? "active-menu" : ""
                    }`}
                  >
                    {data.data[0].attributes.Group}
                  </a>
                </li>
                <li>
                  <a
                    href="/brand"
                    onClick={() => handleMenuClick("brand")}
                    className={`menuitem cataloghi ${
                      activeMenu === "brand" ? "active-menu" : ""
                    }`}
                  >
                    {data.data[0].attributes.Brand}
                  </a>
                </li>
                <li>
                  <a
                    href="/contract"
                    onClick={() => handleMenuClick("contract")}
                    className={`menuitem contatti ${
                      activeMenu === "contract" ? "active-menu" : ""
                    }`}
                  >
                    {data.data[0].attributes.Contract}
                  </a>
                </li>
                <li>
                  <a
                    href="/news"
                    onClick={() => handleMenuClick("news")}
                    className={`menuitem contatti ${
                      activeMenu === "news" ? "active-menu" : ""
                    }`}
                  >
                    {data.data[0].attributes.News}
                  </a>
                </li>
                <li>
                  <a
                    href="/contatti"
                    onClick={() => handleMenuClick("contatti")}
                    className={`menuitem contatti ${
                      activeMenu === "contatti" ? "active-menu" : ""
                    }`}
                  >
                    {data.data[0].attributes.Contatti}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
